/**
 * Work-item dispositions — the accountant's verdict on an inbox item
 * (Atlikta / Atidėti iki / Ne problema / Grąžinti). Survives re-scans.
 */
import { api } from './client';

export type DispositionAction = 'Postponed' | 'Declined' | 'ManualDone' | 'Restore';

export interface DispositionDto {
  id: number;
  agentName: string;
  stableKey: string;
  status: string;
  postponedUntil: string | null;
  reason: string | null;
  actedBy: string;
  actedAtUtc: string;
  title: string | null;
}

export const workItemsApi = {
  dispose: (agentName: string, stableKey: string, action: DispositionAction,
            opts?: { until?: string; reason?: string; title?: string }) =>
    api.post<DispositionDto>('/work-items/dispose', {
      agentName,
      stableKey,
      action,
      until: opts?.until ?? null,
      reason: opts?.reason ?? null,
      title: opts?.title ?? null,
    }),

  dispositions: () => api.get<DispositionDto[]>('/work-items/dispositions'),
};
